define('fetch-training',[],function() {

    var fetchTraining = function(options) {
        options = options || {};

        var dataURL = options.dataURL + options.trainingID + '?classId=' + options.classID + '&previewMode=' + options.previewMode,
            debugMode = options.debugMode,
            onLine = options.onLine,
            tokenID = options.tokenID;

        if (options.dateModified) {
            dataURL += '&dateModified=' + options.dateModified;
        }

        return new Promise(function(resolve, reject) {
            var request,
                res = {
                    lang: null,
                    training: null,
                    user: null
                };

            if (!onLine || !dataURL) {
                if (debugMode) {
                    if (!onLine) {
                        window.console.log('data-context: player is not onLine');
                    } else {
                        window.console.log('data-context: dataURL is not specified');
                    }
                }
                resolve(res);
                return;
            }

            request = new Request(dataURL, {
                method: 'get',
                headers: new Headers({
                    'Authorization-Token': tokenID,
                    'Content-Type': 'application/json'
                })
            });

            fetch(request).then(function(response) {
                return response.json();
            }).then(function(res) {

                if (debugMode) {
                    window.console.log('data-context: loaded data form server');
                    console.dir(res);
                }
                resolve(res);

            }).catch(function(err) {
                reject(err);
            });

        });
    };

    return fetchTraining;
});

